import React, { useCallback, useEffect } from 'react';
import { Card } from '~/ui/card/Card';
import { Flex } from '~/ui/flex/Flex';
import { Overlay } from '~/ui/overlay/Overlay';
import { withTransition } from '~/ui/transition/Transition';
import { TextLocalePage } from './locales/TextLocalePage';
import { PlaybackSpeed } from './playback-speed/PlaybackSpeed';
import { Root } from './Root';
import { OpenSettingsButton } from './OpenSettingsButton';
import { SettingsProvider, useSettingsStore } from './Store';
import { MediumLocalePage } from './locales/MediumLocalePage';
import { useOpenCloseAudioEffect } from '~/ui/audio-effect/useOpenCloseAudioEffect';
import { DarkModePage } from './locales/DarkModePage';
import { SubtitleLocalePage } from './locales/SubtitleLocalePage';
const SettingsCard = withTransition(Card);

const SettingsUI = () => {
  const { open, toggle } = useSettingsStore();
  useOpenCloseAudioEffect(open);

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      toggle(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  return (
    <>
      <OpenSettingsButton />
      <Overlay open={open} onClick={() => toggle(false)}>
        <Flex
          zIndex="dialogs"
          p={{ _: 'sm', sm: 'xl' }}
          minHeight="100%"
          justifyContent={{ _: 'stretch', sm: 'flex-end' }}
          alignItems={{ _: 'flex-end', sm: 'flex-start' }}
          overflow="hidden"
          aria-modal={open}
        >
          <SettingsCard show={open} w={{ _: '100%', sm: 'auto' }}>
            <Root />
            <MediumLocalePage />
            <TextLocalePage />
            <SubtitleLocalePage />
            <DarkModePage />
            <PlaybackSpeed />
          </SettingsCard>
        </Flex>
      </Overlay>
    </>
  );
};

export const Settings = () => (
  <SettingsProvider>
    <SettingsUI />
  </SettingsProvider>
);
